import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { JssNavItem } from '@core/jss-models';
import { NavLinkComponent } from '@core/navigation-ui/nav-link';

@Component({
  selector: 'wl-navigation-domain-links',
  standalone: true,
  imports: [CommonModule, NavLinkComponent],
  templateUrl: './navigation-domain-links.component.html',
  styleUrl: './navigation-domain-links.component.essent.scss',
})
export class NavigationDomainLinksComponent {
  readonly navigationItems = input.required<JssNavItem[]>();
  navigate = output();
}
